import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export function Layout({ children }) {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }) // ✅ מעביר אוטומטית לראש הדף בכל מעבר
  }, [pathname])

  return (
    <div className="min-h-screen flex flex-col">
      {children}
    </div>
  )
}
